import authService from '../../services/AuthService';
const HasFeature = ({ feature, children = null, fallback = null }) => {
    if (!children)
        return null;
    if (!authService.hasFeature(feature)) {
        return fallback;
    }
    return children;
};
export default HasFeature;
